<template>
    <delete-student-form 
        v-if="deleteStudentFormFlag"
        :student="deleteStudentFormData"
        @close="deleteStudentFormFlag = false"
        @acceptDeleteStudent="deleteStudentVM($event)"
        @updateStudents="updateUsers" 
    />
    <new-student-form :show = "showNewStudentForm" @close="showNewStudentForm = false" @updateStudents="updateUsers"/>
    <student-card  
        v-if="showStudentCardFlag" 
        :currentStudent="currentStudent" 
        @close="() => {showStudentCardFlag = false; fullCardFlag = false; updateUsers(); cleanRoute()}"
        @updateUsers="updateUsers" 
        @fullCard="fullCardFlag = true"
    />
    <!-- <FullStudentCard v-if="false" /> -->
    <!-- <NewFullStudentCard v-if="true" /> -->
    <div v-if="currentStatusFlag" @click="currentStatusFlag = false" class="absolute w-full bg-transparent h-full overflow-hidden top-0 left-0 z-0"></div>
    <div v-if="!fullCardFlag && tableViewFlag" class="overflow-y-auto">
        <menu-bar v-model="searchQuery" v-model:page="currentPage" :maxPage="maxPage" @startFilter="filterAllStudents" @openFilters="" @addStudent="showNewStudentForm = true" />

        <div class="border-b-[1px] border-white w-[90%] mx-auto flex justify-end mt-[16px] mb-[16px]">
            <!-- <div class="text-white">
                <span class="text-[28px] font-semibold">{{ allActiveStudentsCount }}</span> активних
            </div> -->
            <!-- <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ allDebtStudentsCount }}</span> боржників
            </div> -->
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ totalStudentsCount }}</span> гравців
            </div>
        </div>

        <keep-alive>
        <div class=" w-[90%] mx-auto mt-3 mb-5 rounded-[10px] overflow-y-auto">
            <table class="w-full">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-medium text-sm "></th>
                        <th class="px-3 py-2 w-[15%] text-start font-medium text-[12px] ">Ім'я</th>
                        <th class="px-3 py-2 w-[10%] text-start font-medium text-[12px] ">Група</th>
                        <th class="px-3 py-2 w-[10%] text-start font-medium text-[12px] ">Телефон</th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Рейтинг
                            </div>
                        </th>
                        <!-- @click="balanceNewFilter" -->
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium flex justify-end align-middle items-center text-sm">
                            <div class="text-end text-[12px]">
                                Відвідуваність
                            </div>
                            <!-- <div class="flex  flex-col justify-between items-center align-middle">
                                <div v-if="balanceVector == 'desc'" class="text-[#4F46E5] text-center mt-[4px]">
                                    <img src="@/desktopApp/assets/icons/angle-small-up.svg" class="w-3">
                                </div>
                                <div v-if="balanceVector == 'asc'" class="text-white text-center mt-[4px]">
                                    <img src="@/desktopApp/assets/icons/angle-small-down.svg" class="w-3">
                                </div>
                                <div v-else></div>
                            </div> -->
                        </th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Зіграні матчі
                            </div>
                        </th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Хвилини на полі
                            </div>
                        </th>
                        <th class="w-[5%]" v-if="screenWidth > 1450"></th>
                        <th class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                            <div @click="currentStatusFlag = !currentStatusFlag" v-if="!showStudentCardFlag && !showNewStudentForm"  class="cursor-pointer w-[178px] text-[12px] z-[-40] pr-[26px]">Статус</div>
                            <div v-if="currentStatusFlag" class="absolute top-[40px] right-[-70px] bg-[#252526] border-b-[1px] border-x-[1px] border-[#374957] rounded-b-[10px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.4)] px-2 py-3 flex">
                                <div class="flex justify-center items-center mx-2">
                                    <input @change="changeStatus('active')" :checked="currentStatuses.includes('active')" type="checkbox" class="mr-[2px] w-[20px] bg-white cursor-pointer">
                                    <div class="bg-[#8FC408] mx-2 h-[18px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-white">
                                        <div class="block">
                                            Активний
                                        </div>
                                    </div>  
                                </div>
                                <div class="flex justify-center items-center mx-2">
                                    <input @change="changeStatus('archive')" :checked="currentStatuses.includes('archive')" type="checkbox" class="mr-[2px] cursor-pointer">
                                    <div class="bg-[#D9D9D9] mx-2 h-[18px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-[#78797C]">
                                        Архів
                                    </div> 
                                </div>
                            </div>
                        </th>
                        <th class="px-3 w-[35%] py-2 text-start font-medium text-sm"></th>
                    </tr>
                </thead>
                <tbody v-if="allStudents.length > 0">
                    <new-student-row
                        v-for="student in allStudents" 
                        @openStudentCard="showStudentCard(student)"
                        @deleteStudent="deleteStudentFormData = student; deleteStudentFormFlag = true"
                        @removeStudentFromArchive="deleteStudentFromArchive(student)"
                        :key="student.student_id" 
                        :student="student"
                    />
                </tbody>
            </table>
        </div>
        </keep-alive>
        <div v-if="loading" class="z-50 fixed w-full h-full">
            <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#DA4167] border-t-transparent absolute top-[50%] left-[50%] ml-[-160px] mt-[-90px]"></div>
        </div>
        <div class="w-full mt-[14px] flex items-center justify-center" v-else-if="allStudents.length == 0">
            <p class="text-[#A3A3C2] text-[16px]">Учнів не знайдено</p>
        </div>  
    </div>
</template>

<script>
    import { onMounted, ref, computed, watch } from 'vue'
    import { getAllStudents, deleteStudent, getStudentById, getBalanceState, getTrainerGroupsRequest, getAllCompletedTrainingsByStudentId, getStudentsCount, getActiveStudentsCount, getAllStudentsListInGroup, getDebtStudentsCount, getArchiveStudentsCount, addStudentToArchive, removeStudentFromArchive, getAllGroups } from '@/desktopApp/services/apiRequests'
    import { useRoute, useRouter } from 'vue-router'
    import MenuBar from './components/MenuBar.vue'
    import StudentRow from './components/StudentRow.vue'
    import NewStudentForm from './components/NewStudentForm.vue'
    import StudentCard from './components/StudentCard/StudentCard.vue'
    import NewStudentRow from './components/NewStudentRow.vue'
    import DeleteStudentForm from './components/DeleteStudentForm.vue'
    import FullStudentCard from './components/FullStudentCard/FullStudentCard.vue'
    import NewFullStudentCard from './components/NewFullStudentCard/NewFullStudentCard.vue'
    import { useMainStore } from '@/desktopApp/stores/mainStore'

    export default {
        setup() {
            const route = useRoute()
            const router = useRouter()
            const store = useMainStore()

            const maybeStudentId = computed(() => {
                return route.params.id
            })

            const allStudents = ref([])
            const showNewStudentForm = ref(false)
            const showStudentCardFlag = ref(false)
            const currentStudent = ref({})
            const deleteStudentFormFlag = ref(false)
            const deleteStudentFormData = ref({})
            const cloneAllStudents = ref([])
            const searchQuery = ref('')
            const currentPage = ref(1)
            const maxPage = ref(1)
            const loading = ref(false)
            const screenWidth = ref(window.innerWidth)

            const tableViewFlag = ref(false)

            const allDebtStudentsCount = ref(0)
            const allActiveStudentsCount = ref(0)
            const allArchiveStudentsCount = ref(0)

            const fullCardFlag = ref(false)

            const balanceVector = ref(null)
            const balanceNewFilter = () => {
                balanceVector.value = balanceVector.value === null ? 'asc' : balanceVector.value === 'asc' ? 'desc' : null
                updateUsers()
                // filterAllStudents()
            }

            const isMethodist = computed(() => {
                const position = store.trainer?.position || ''
                return position.toLowerCase().includes('метод') || position.toLowerCase().includes('method')
            })

            const isGoalkeeperTrainer = computed(() => {
                const position = (store.trainer?.position || '').toLowerCase()
                return position.includes('goalkeeper_trainer')
            })

            const isIndividualTrainer = computed(() => {
                const position = (store.trainer?.position || '').toLowerCase()
                return position.includes('individual_trainer')
            })

            const pageSize = 20
            const totalStudentsCount = ref(0)

            watch(searchQuery, () => {
                currentPage.value = 1
                updateUsers()
            })

            const currentStatuses = ref(['active'])
            const changeStatus = async (status) => {
                if (currentStatuses.value.includes(status)) {
                    currentStatuses.value = currentStatuses.value.filter((item) => item !== status)
                } else {
                    currentStatuses.value.push(status)
                }
                currentPage.value = 1
                await updateUsers()
                // filterAllStudents()
            }
            const currentStatusFlag = ref(false)

            // const filterAllStudents = () => {
            //     let visibleResult = []
                
            //     if (currentStatuses.value.length === 0) {
            //         visibleResult = []
            //     } else {
            //         currentStatuses.value.forEach((status) => {
            //             if (status === 'active') visibleResult.push(...cloneAllStudents.value.filter((student) => student.status.includes('active') && student.balance >= 0))
            //             if (status === 'archive') visibleResult.push(...cloneAllStudents.value.filter((student) => student.status.includes('archive')))
            //             if (status === 'debtor') visibleResult.push(...cloneAllStudents.value.filter((student) => student.balance < 0))
            //         })
            //     }
               
            //     if (balanceVector.value === 'none') visibleResult = visibleResult
            //     if (balanceVector.value === 'up') visibleResult = visibleResult.sort((a, b) => b.balance - a.balance)
            //     if (balanceVector.value === 'down') visibleResult = visibleResult.sort((a, b) => a.balance - b.balance)

            //     searchQuery.value = searchQuery.value.toLowerCase()
            //     visibleResult = visibleResult.filter((student) => {
            //         return student.name.toLowerCase().includes(searchQuery.value) || student.surname.toLowerCase().includes(searchQuery.value) || student.phone.toLowerCase().includes(searchQuery.value) || student.group_name.toLowerCase().includes(searchQuery.value)
            //     })

            //     console.log('visible result', visibleResult)
            //     allStudents.value = visibleResult
            // }

            const updatePaginationMeta = (total) => {
                totalStudentsCount.value = total
                maxPage.value = Math.max(1, Math.ceil(total / pageSize))
                if (currentPage.value > maxPage.value) {
                    currentPage.value = maxPage.value
                }
            }

            const updateUsers = async () => {
                loading.value = true
                allStudents.value = []

                try {
                    let students = []

                    if (isGoalkeeperTrainer.value || isIndividualTrainer.value) {
                        let allGroupsList = []
                        try {
                            const groupsRes = await getAllGroups()
                            allGroupsList = groupsRes?.data || []
                        } catch (e) {
                            allGroupsList = store.trainer_groups || []
                        }

                        if (allGroupsList.length) {
                            const groupStudents = await Promise.all(
                                allGroupsList.map((group) => getAllStudentsListInGroup(group.group_id))
                            )
                            const merged = groupStudents
                                .filter(Boolean)
                                .flatMap((groupList) => (Array.isArray(groupList) ? groupList : groupList?.data || []))
                            const uniqueStudents = []
                            const seenIds = new Set()
                            merged.forEach((student) => {
                                if (student?.student_id && !seenIds.has(student.student_id)) {
                                    seenIds.add(student.student_id)
                                    uniqueStudents.push(student)
                                }
                            })
                            students = isGoalkeeperTrainer.value
                                ? uniqueStudents.filter(s => s.amplua === 'ВР')
                                : uniqueStudents
                        }
                        updatePaginationMeta(students.length)
                    } else if (isMethodist.value) {
                        const res = await getAllStudents(
                            pageSize,
                            (currentPage.value - 1) * pageSize,
                            balanceVector.value,
                            searchQuery.value,
                            null,
                            null,
                            currentStatuses.value
                        )
                        const methodistStudents = Array.isArray(res?.data) ? res.data : Array.isArray(res?.data?.data) ? res.data.data : []
                        students = methodistStudents
                        try {
                            const allUsersCount = await getStudentsCount()
                            updatePaginationMeta(allUsersCount || students.length)
                        } catch (error) {
                            updatePaginationMeta(students.length)
                        }
                    } else {
                        if (!store.trainer_groups?.length) {
                            try {
                                await store.getTrainerGroups()
                            } catch (error) {
                                console.error('Не вдалось отримати групи тренера', error)
                            }
                        }

                        if (store.trainer_groups?.length) {
                            const groupStudents = await Promise.all(
                                store.trainer_groups.map((group) => getAllStudentsListInGroup(group.group_id))
                            )
                            const merged = groupStudents
                                .filter(Boolean)
                                .flatMap((groupList) => (Array.isArray(groupList) ? groupList : groupList?.data || []))
                            const uniqueStudents = []
                            const seenIds = new Set()
                            merged.forEach((student) => {
                                if (student?.student_id && !seenIds.has(student.student_id)) {
                                    seenIds.add(student.student_id)
                                    uniqueStudents.push(student)
                                }
                            })
                            students = uniqueStudents
                            updatePaginationMeta(students.length)
                        } else {
                            updatePaginationMeta(0)
                        }
                    }

                    if (currentStatuses.value.length) {
                        students = students.filter((student) => currentStatuses.value.some((status) => student.status?.includes(status)))
                    } else {
                        students = []
                    }

                    if (!isMethodist.value) {
                        updatePaginationMeta(students.length)
                    }

                    if (searchQuery.value) {
                        const search = searchQuery.value.toLowerCase()
                        students = students.filter((student) => {
                            const fullName = `${student.name || ''} ${student.surname || ''}`.toLowerCase()
                            const phone = (student.phone || '').toLowerCase()
                            const groupName = (student.group_name || '').toLowerCase()
                            return fullName.includes(search) || phone.includes(search) || groupName.includes(search)
                        })
                    }

                    if (!isMethodist.value) {
                        updatePaginationMeta(students.length)
                        const start = (currentPage.value - 1) * pageSize
                        students = students.slice(start, start + pageSize)
                    }

                    await Promise.all(
                        students.map(async (student) => {
                            const balance = await getBalanceState(student.balance_id)
                            student.balance = Number(balance).toFixed(2)
                            return student
                        })
                    )

                    allStudents.value = students
                } catch (error) {
                    console.error('Не вдалось отримати список учнів', error)
                    allStudents.value = []
                    updatePaginationMeta(1)
                } finally {
                    loading.value = false
                }
            }


            const deleteStudentVM = async (student) => {
                if (student.status.includes('active')) {
                    const res = await addStudentToArchive(student.student_id)
                    updateUsers()
                    deleteStudentFormFlag.value = false
                    await statsUpdate()
                } else if (student.status.includes('archive')) {
                    const res = await deleteStudent(student.student_id)
                    if (res.status === 200) {
                        updateUsers()
                        deleteStudentFormFlag.value = false
                    }
                    await statsUpdate()
                }
            }

            const deleteStudentFromArchive = async (student) => {
                const res = await removeStudentFromArchive(student.student_id)
                updateUsers()
                deleteStudentFormFlag.value = false
                await statsUpdate()
            }

            const statsUpdate = async () => {
                const allDebtStudentsCountRes = await getDebtStudentsCount()
                console.log('allDebtStudentsCountRes --------- ', allDebtStudentsCountRes)
                allDebtStudentsCount.value = allDebtStudentsCountRes
                const allActiveStudentsCountRes = await getActiveStudentsCount()
                allActiveStudentsCount.value = allActiveStudentsCountRes
                const allArchiveStudentsCountRes = await getArchiveStudentsCount()
                allArchiveStudentsCount.value = allArchiveStudentsCountRes
            }

            watch(maybeStudentId, async () => {
                if (maybeStudentId.value) {
                    const student = await getStudentById(maybeStudentId.value)
                    console.log('student333 ---------- ', maybeStudentId.value)
                    if (student) {
                        showStudentCard(student.data.student)
                    }
                }
            })

            onMounted(async () => {
                loading.value = true
                
                if (maybeStudentId.value) {
                    const student = await getStudentById(maybeStudentId.value)
                    console.log('student333 ---------- ', student.data)
                    if (student) {
                        showStudentCard(student.data.student)
                    }
                    tableViewFlag.value = true
                } else {
                    tableViewFlag.value = true
                    await updateUsers()
                    cloneAllStudents.value = [...allStudents.value]
                    await statsUpdate()

                    window.addEventListener('resize', () => {
                        screenWidth.value = window.innerWidth
                    })
                }

                loading.value = false
            })

            const showStudentCard = (student) => {
                console.log('student ---------- ', student)
                currentStudent.value = student
                showStudentCardFlag.value = true
            }

            const formatDate = (date) => {
                return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
            }

            watch(currentPage, async () => {
                if (currentPage.value < 1) currentPage.value = 1
                if (currentPage.value > maxPage.value) currentPage.value = maxPage.value
                await updateUsers()
            })

            const cleanRoute = () => {
                //delete params from url

                router.push('/students')
            }

            return {
                allStudents,
                showNewStudentForm,
                formatDate,
                updateUsers,
                showStudentCard,
                showStudentCardFlag,
                currentStudent,
                deleteStudentFormFlag,
                deleteStudentFormData,
                deleteStudentVM,
                balanceVector,
                balanceNewFilter,
                currentStatuses,
                changeStatus,
                currentStatusFlag,
                searchQuery,
                currentPage,
                maxPage,
                totalStudentsCount,
                loading,
                screenWidth,
                allDebtStudentsCount,
                allActiveStudentsCount,
                allArchiveStudentsCount,
                deleteStudentFromArchive,
                fullCardFlag,
                cleanRoute,
                tableViewFlag
            }
        },

        components: {
            MenuBar,
            StudentRow,
            NewStudentForm,
            StudentCard,
            NewStudentRow,
            DeleteStudentForm,
            FullStudentCard,
            NewFullStudentCard
        }
    }
</script>
